type EventConfig = {
    defaults: Record<string, string>;
    banner: {
        src: string;
        alt: string;
        text: string;
    };
};

export type EventName = 'NorShipping';

const events = {
    NorShipping: {
        defaults: {
            booking_from: '2027-06-07',
            booking_to: '2027-06-11',
            lat_sw: '59.81196986144164',
            lng_sw: '10.614205472287523',
            lat_ne: '60.04524856475314',
            lng_ne: '11.163150897612468',
            country: 'Norge',
            city: 'Oslo',
            no_of_beds_from: '1',
        },
        banner: {
            src: 'https://images.finncdn.no/dynamic/1600w/fhh/event-banners/nor-shipping.png',
            alt: 'Nor-Shipping NEXT — Oslo 07-11 June',
            text: 'I samarbeid med Nor-Shipping',
        },
    },
} satisfies Record<EventName, EventConfig>;

const isValidEvent = (event: string): event is EventName => event in events;

export const getEventConfig = (event: string | undefined): EventConfig | null => {
    if (!event || !isValidEvent(event)) return null;
    return events[event];
};

export const parseEvent = (value: string | string[] | undefined): EventName | undefined => {
    if (typeof value === 'string' && isValidEvent(value)) return value;
    return undefined;
};

export const buildEventRedirect = (
    query: Record<string, string | string[] | undefined>,
): { destination: string; permanent: false } | null => {
    const event = parseEvent(query.event);
    const eventConfig = getEventConfig(event);
    if (!eventConfig) return null;

    const missingDefaults: Record<string, string> = {};
    for (const [key, value] of Object.entries(eventConfig.defaults)) {
        if (!query[key]) missingDefaults[key] = value;
    }
    if (Object.keys(missingDefaults).length === 0) return null;

    const params = new URLSearchParams({
        ...missingDefaults,
        ...Object.fromEntries(Object.entries(query).filter((entry): entry is [string, string] => typeof entry[1] === 'string')),
    });
    return { destination: `/resultat/?${params.toString()}`, permanent: false };
};
